//#region IMPORTS
import { useEffect, useRef, useState } from "react";
import { CellContext } from "@tanstack/react-table";
import classNames from "../../helpers/classNames";
//#endregion

export default function InstoreOrderDetailTableEditableCell<TData, TValue>(
  item: CellContext<TData, TValue> & { disabled?: boolean }
) {
  //#region SETUP
  const { getValue, row, column, table, disabled = false } = item;

  const initialValue = getValue();
  const [value, setValue] = useState<TValue>(
    (initialValue ?? "") as unknown as TValue
  );

  const inputRef = useRef<HTMLInputElement>(null);
  //#endregion

  //#region LOGIC
  const commitValue = () => {
    table.options.meta?.updateData(column.id, value, row.original);
  };

  const focusNextInput = () => {
    const inputs = Array.from(
      document.querySelectorAll<HTMLInputElement>("input[data-grid-input]")
    );

    const index = inputs.findIndex((el) => el === inputRef.current);
    if (index >= 0 && index + 1 < inputs.length) {
      inputs[index + 1].focus();
    }
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      commitValue();
      e.currentTarget.blur();
      return;
    }

    if (e.key === "Tab") {
      e.preventDefault();
      commitValue();
      focusNextInput();
    }
  };

  const onBlur = () => {
    commitValue();
  };

  useEffect(() => {
    setValue((initialValue ?? "") as unknown as TValue);
  }, [initialValue]);
  //#endregion

  //#region RENDER
  return (
    <input
      ref={inputRef}
      data-grid-input // tab select inputs
      value={(value ?? "") as unknown as string}
      disabled={disabled}
      onChange={(e) => setValue(e.target.value as unknown as TValue)}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      className={classNames(
        disabled
          ? "bg-white"
          : "placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:text-purple-800 focus:ring-purple-500 bg-slate-50 focus:bg-purple-50 focus:font-semibold",
        "block rounded-md border-0 py-1.5 sm:text-sm sm:leading-6 "
      )}
    />
  );
  //#endregion
}
